import { render } from "./MoreLess.vue?vue&type=template&id=794a5fd0"
import script from "./MoreLess.vue?vue&type=script&lang=js"
export * from "./MoreLess.vue?vue&type=script&lang=js"

import "./MoreLess.vue?vue&type=style&index=0&id=794a5fd0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__